import { createTheme } from '@mui/material/styles';
import { colors } from 'Constants/Colors';

export const MexlogTheme = createTheme({
  palette: {
    MexlogGreen: {
      main: colors.GREEN,
    },
  },
  typography: {
    fontFamily: ['Roboto', 'Metropolis', 'Arial', 'Quicksand', '"Helvetica Neue"'].join(','),
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: 'Metropolis',
        },
      },
    },
  },
});

export default MexlogTheme;
